<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div [formGroup]="parentFormGroup" class="mb-3">
  <div class="d-flex justify-content-between">
    <div class="modal-section-title">
      <span *ngIf="showName">
        {{ parentFormGroup.value[showNameFrom] }}
      </span>
      {{ 'CONTACT_PERSON_COMPONENT.CONTACT_PERSONS' | translate }}
    </div>

    <button type="button" class="btn btn-xs btn-primary float-end mb-1" (click)="addContactPerson()">
      {{ 'CONTACT_PERSON_COMPONENT.ADD_CONTACT_PERSON' | translate }}
    </button>
  </div>

  <div formArrayName="contact_persons">
    <div class="divider" *ngIf="parentFormGroup.get('contact_persons')?.controls.length < 1"></div>
    <div
      *ngFor="let contactPerson of parentFormGroup.get('contact_persons')?.controls; let k = index"
      class="single-contact-person mb-2"
    >
      <button
        type="button"
        class="move-btn move-down"
        (click)="moveDown(k)"
        *ngIf="
          parentFormGroup.get('contact_persons')?.controls.length > 1 &&
          k + 1 !== parentFormGroup.get('contact_persons')?.controls.length
        "
      >
        <i class="fal fa-long-arrow-down"></i>
      </button>

      <button
        type="button"
        class="move-btn move-up"
        (click)="moveUp(k)"
        *ngIf="parentFormGroup.get('contact_persons')?.controls.length > 1 && k !== 0"
      >
        <i class="fal fa-long-arrow-up"></i>
      </button>

      <button
        type="button"
        class="remove-contact-person"
        (click)="removeContactPerson(k)"
        *ngIf="parentFormGroup.get('contact_persons')?.controls.length > 1 || !required"
      >
        <i class="fal fa-times"></i>
      </button>
      <div [formGroupName]="k">
        <div class="row max-width">
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'CONTACT_PERSON_COMPONENT.TITLE' | translate }}</label>
              <app-type-select
                [parentFormGroup]="contactPerson"
                [groupType]="'contact_person_title'"
                [passFormControlName]="'title_id'"
                [bindValue]="'id'"
              ></app-type-select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'CONTACT_PERSON_COMPONENT.FIRST_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="first_name" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label>{{ 'CONTACT_PERSON_COMPONENT.LAST_NAME' | translate }}</label>
              <input type="text" class="form-control" formControlName="last_name" />
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label>{{ 'CONTACT_PERSON_COMPONENT.POSITION' | translate }}</label>
              <input type="text" class="form-control" formControlName="position" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12" *ngIf="withEvent">
            <div class="row">
              <div class="col-sm-10">
                <div class="form-group">
                  <app-event-group-select [parentFormGroup]="contactPerson"></app-event-group-select>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    [attr.id]="'company' + '-' + k"
                    formControlName="show"
                  />
                  <label class="custom-control-label mt-4" [attr.for]="'company' + '-' + k">
                    {{ 'CONTACT_PERSON_COMPONENT.EVENT_GROUP_SHOW' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <app-contact class="app-contact" [parentFormGroup]="contactPerson" [cols]="cols" [showNote]="showNote"></app-contact>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
